import { FormLayout, Label, TextInput } from '@kcftech/design-system';
import { RegisterOptions, UseFormReturn, useFormState } from 'react-hook-form';

export type AssetCategoryFormData = Readonly<{
    name: string;
}>;

const maxAssetCategoryNameLength = 50;

const getNameRules = (
    siblingShortNames: string[],
): RegisterOptions<AssetCategoryFormData, 'name'> => ({
    required: 'Please enter the asset category name',
    maxLength: {
        value: maxAssetCategoryNameLength,
        message: `Asset category name cannot be greater than ${maxAssetCategoryNameLength} characters`,
    },
    validate: (value) => {
        if (value.trim() === '') {
            return 'Please enter the asset category name';
        }

        if (siblingShortNames.includes(value.trim())) {
            return 'Name already exists. Please enter a unique name.';
        }
        return undefined;
    },
});

export type AssetCategoryFormContentProps = Readonly<{
    form: UseFormReturn<AssetCategoryFormData>;
    siblingShortNames: string[];
    parentCategoryName?: string;
}>;

export function AssetCategoryFormContent({
    form,
    siblingShortNames,
    parentCategoryName,
}: AssetCategoryFormContentProps) {
    const {
        register,
        control,
    } = form;

    const {
        errors,
    } = useFormState({
        control,
    });

    return (
        <FormLayout>
            {parentCategoryName && (
                <Label label="Parent Category">
                    <div className="mt-5">{parentCategoryName}</div>
                </Label>
            )}
            <TextInput
                label="Name"
                error={errors.name?.message}
                required
                placeholder="Enter a name for the asset category"
                {...register('name', getNameRules(siblingShortNames))}
            />
        </FormLayout>
    );
}
